import { QualityGroupProps } from 'components/Myself/components/QualityGroup/props';
import React, { Component } from 'react';

import QualityGroupComponent from './QualityGroupComponent';

export default class QualityGroupContainer extends Component<QualityGroupProps> {
  static displayName = 'QualityGroupContainer';

  handleEnterWaypoint = () => {
    const { id, onEnterWaypoint } = this.props;
    // console.info(`waypoint entry: ${name}`); // eslint-disable-line no-console
    onEnterWaypoint(id);
  };

  render = () => {
    const { name, filterString } = this.props;
    return (
      <QualityGroupComponent
        filterString={filterString}
        onEnterWaypoint={this.handleEnterWaypoint}
        name={name}
      />
    );
  }
}
